export default __webpack_public_path__ + "static/assets/a0735dd89cca8501d49ae165f7770f02.svg";